import React from 'react';

function SeoHero() {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="seo-hero-section">
      {/* Subtle background glow */}
      <div className="seo-hero-bg-glow"></div>

      <div className="container seo-hero-container">
        <div className="seo-hero-grid">
          {/* Left Column: Title, Description & 2 Buttons */}
          <div className="seo-hero-left">
            <h1 className="seo-hero-title">
              <span className="seo-red-title">SEO Services In Pakistan</span> To Rank You On Top!
            </h1>

            <p className="seo-hero-desc">
              Tired of your business getting lost in the digital race? Assume your website is taking over search results, attracting a flood of organic traffic, and converting visitors into loyal customers. As the best SEO services provider in Pakistan, we don't promise top rankings but deliver sustainable strategies. We ensure your brand stands out where it matters most, driving real growth and visibility. Stop letting competitors steal your position. Claim your free SEO audit today and let's get you to the top!
            </p>

            <div className="seo-hero-btn-group">
              <a href="tel:+923177770002" className="btn-seo-call">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="btn-seo-icon">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span>Call Us</span>
              </a>

              <button className="btn-seo-quote" onClick={handleQuoteClick}>
                <span>Get Free Quote</span>
              </button>
            </div>
          </div>

          {/* Right Column: SEO Graphic Image */}
          <div className="seo-hero-right">
            <div className="seo-hero-img-wrapper">
              <img 
                src="/assets/images/seo-services/seo-img1.png" 
                alt="SEO Services In Pakistan To Rank You On Top" 
                className="seo-hero-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SeoHero;
